// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6648":"e0c32737f3781e85","9341":"ff887d0263ddd8d9","9964":"990de3d7b6cfc6b1"}[chunkId] + ".css";
};